module.exports = __webpack_public_path__ + "media/images/easypin/crosshair-7f4903994e6c6524956aac5bf0d79125.png";